export default "__VITE_ASSET__e83dc49b__"